/* cart-drawer-fix.js — Atelier Cohen-Dubois — v2
   Corrige : le tiroir panier ne s'ouvre pas quand /cart/add.js renvoie sections: null,
   et affiche un contenu périmé quand on force l'ouverture via l'icône panier.

   v2 : attend customElements.whenDefined(). La v1 sortait en silence lorsqu'elle
        s'exécutait avant cart-drawer.js — l'ordre de chargement n'importe plus. */
(function () {
  if (!window.customElements) return;

  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    if (proto.__acdPatched) return;
    proto.__acdPatched = true;

    /* Récupère le contenu du tiroir indépendamment de la réponse d'ajout. Renvoie une promesse. */
    proto.refreshCart = function () {
      var self = this;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var next = doc.querySelector('cart-drawer');
          if (next) self.innerHTML = next.innerHTML;
        })
        .catch(function (e) { console.error('[cart-drawer] refresh echoue', e); });
    };

    /* Tout ce qui doit se produire APRES le rendu — y compris l'ouverture. */
    proto.afterRender = function (parsed) {
      var overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay && !overlay.dataset.acdBound) {
        overlay.dataset.acdBound = '1';
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
      if (typeof initUpsellSlider === 'function') {
        try { initUpsellSlider(); } catch (e) { console.error('[cart-drawer] upsell', e); }
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsed }));
    };

    /* Rendu tolerant aux pannes : l'ouverture n'est plus conditionnee au succes du rendu. */
    proto.renderContents = function (parsed) {
      var self = this;
      var inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      this.classList.remove('is-empty');
      this.productId = parsed && parsed.id;

      var sections = parsed && parsed.sections;

      if (sections) {
        try {
          this.getSectionsToRender().forEach(function (s) {
            var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
            var html = sections[s.id];
            if (target && html) target.innerHTML = self.getSectionInnerHTML(html, s.selector);
          });
          this.afterRender(parsed);
          return;
        } catch (e) {
          console.error('[cart-drawer] rendu des sections echoue, repli sur refreshCart', e);
        }
      }

      /* Repli : sections absentes ou rendu en erreur → on recupere le contenu, puis on ouvre. */
      this.refreshCart().then(function () { self.afterRender(parsed); });
    };

    /* L'icone panier rafraichit le contenu avant d'ouvrir : plus jamais d'affichage perime. */
    function bindIcon() {
      var icon = document.querySelector('#cart-icon-bubble');
      var drawer = document.querySelector('cart-drawer');
      if (!icon || !drawer || icon.dataset.acdBound) return;
      icon.dataset.acdBound = '1';
      icon.addEventListener('click', function () { drawer.refreshCart(); }, true);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindIcon);
    else bindIcon();
  });
})();
